/** Build-time metadata: never infer a deployed release from the package version. */
export function ReleaseVersion() {
  const version = import.meta.env.VITE_RELEASE_VERSION?.trim();
  const releaseCandidate = version?.match(/^v?\d+\.\d+\.\d+-rc\.(\d+)$/i);
  const label = version ? (releaseCandidate ? `RC${releaseCandidate[1]}` : version) : "LOCAL";
  const description = version ? `Application release ${version}` : "Local build — no release tag";

  return <span className="release-version" title={description} aria-label={description}>{label}</span>;
}
